<div mat-dialog-content>
  <h1>{{ title }}</h1>
  <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions>
  @if (cancelText) {
    <button mat-stroked-button (click)="close()">
      {{ cancelText }}
    </button>
  }
  @if (!cancelText) {
    <button mat-stroked-button (click)="close()">
      Cancelar
    </button>
  }
  @if (confirmText) {
    <button
      mat-raised-button
      (click)="confirm()"
      color="accent"
      >
      {{ confirmText }}
    </button>
  }
  @if (!confirmText) {
    <button
      mat-raised-button
      (click)="confirm()"
      color="accent"
      >
      Sí
    </button>
  }
</div>
